<template>
  <div v-if="errors[field]">
    <div
      class="invalid-feedback d-block"
      v-for="message in errors[field]"
      :key="message"
    >
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['errors', 'field'],
};
</script>
